import { useParams } from "react-router-dom";
import { useFormBuilder } from "../../../../hooks/useFormBuilder";
import FormBuilderHeader from "./FormBuilderHeader";
import FormBuilderEditorView from "./FormBuilderEditorView";


export default function FormBuilder() {
  const { templateId } = useParams<{ templateId: string }>();

  const {
    templateState,
    setTemplateState,
    // activeView,
    // setActiveView,
    currentSection,
    setCurrentSection,
    loading,
    error,
  } = useFormBuilder(templateId || "");

  if (!templateId) {
    return (
      <div className="p-8 text-center text-red-500">
        Template ID is missing in the URL.
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full text-gray-600">
        Loading form template...
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-8 text-center text-red-500">
        Failed to load template.
        <br />
        <span className="text-gray-500 text-sm">
          {String(error?.message || error)}
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 w-full h-full">
      <FormBuilderHeader />

      <FormBuilderEditorView
        templateState={templateState}
        setTemplateState={setTemplateState}
        currentSection={currentSection}
        setCurrentSection={setCurrentSection}
      />
    </div>
  );
}
